export type ConnectionStatus = 'connected' | 'reconnecting' | 'disconnected';
export type ConnectionIssueTone = 'warning' | 'danger';

export type IntelligenceLiveConnectionPhase =
  | 'idle'
  | 'connecting'
  | 'open'
  | 'reconnecting';

export interface IntelligenceLiveConnectionSnapshot {
  phase: IntelligenceLiveConnectionPhase;
  monitorCount: number;
  updatedAt: number;
}

export interface ConnectionStatusViewModel {
  status: ConnectionStatus;
  hasIssue: boolean;
  tone: ConnectionIssueTone | null;
  title: string | null;
  detail: string | null;
  srLabel: string;
}

export const CONNECTION_STATUS_COPY: Record<
  Exclude<ConnectionStatus, 'connected'>,
  {
    detail: string;
    srLabel: string;
    title: string;
    tone: ConnectionIssueTone;
  }
> = {
  reconnecting: {
    tone: 'warning',
    title: 'Live updates reconnecting',
    detail: 'Trying to recover the live connection.',
    srLabel: 'Live updates reconnecting. Trying to recover the live connection.',
  },
  disconnected: {
    tone: 'danger',
    title: 'You are offline',
    detail: 'Check your internet connection.',
    srLabel: 'You are offline. Check your internet connection.',
  },
};

export const RECONNECTING_STATUS_DEBOUNCE_MS = 800;
export const CONNECTED_STATUS_STABILIZE_MS = 400;
